import { MultiShopSelectPlatformType } from "@/components/MultiShopSelect/types";
import OrderTag from "@/enum/OrderTag";

const PLATFORM_DEFAULT_WAYBILL_TEMPLATE_CACHE = "__PLATFORM_DEFAULT_WAYBILL_TEMPLATE_CACHE__";

const ALI_TAG_DEFAULT_WAYBILL_TEMPLATE_CACHE = "__ALI_TAG_DEFAULT_WAYBILL_TEMPLATE_CACHE__";

function getInt(value) {
    return parseInt(value, 10);
}

export default class MultiPlatformStorageManager {
    static setPlatformDefaultWaybillTemplate(type: MultiShopSelectPlatformType, id: number) {
        localStorage.setItem(PLATFORM_DEFAULT_WAYBILL_TEMPLATE_CACHE + type, String(id));
    }

    static getPlatformDefaultWaybillTemplate(type: MultiShopSelectPlatformType) {
        return getInt(localStorage.getItem(PLATFORM_DEFAULT_WAYBILL_TEMPLATE_CACHE + type));
    }

    /** 单店铺页面打印和多店铺页面打印使用独立缓存 */

    static setAliTagDefaultWaybillTemplate(shopId: number, tag: OrderTag, id: number) {
        localStorage.setItem((shopId || "").toString() + ALI_TAG_DEFAULT_WAYBILL_TEMPLATE_CACHE + tag, String(id));
    }

    static getAliTagDefaultWaybillTemplate(shopId: number, tag: OrderTag) {
        return getInt(localStorage.getItem((shopId || "").toString() + ALI_TAG_DEFAULT_WAYBILL_TEMPLATE_CACHE + tag));
    }
}
